(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productos-recomendados"] && !Shopify.designMode) return;
  try {
    
(function () {
  function loadInto(el) {
    if (!el || !el.dataset || !el.dataset.url) return;

    var request = new XMLHttpRequest();
    request.open('GET', el.dataset.url);
    request.onload = function () {
      if (request.status < 200 || request.status >= 300) return;

      var container = document.createElement('div');
      container.innerHTML = request.response;

      var incoming = container.querySelector('.productos-recomendados');
      if (!incoming) return;

      el.innerHTML = incoming.innerHTML;
    };
    request.send();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.productos-recomendados[data-url]').forEach(loadInto);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    var section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (section) initAll(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products-copilot"] && !Shopify.designMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var section = document.querySelector('.related-products-carousel');
  if (!section) return;

  var request = new XMLHttpRequest();
  request.open('GET', section.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var temp = document.createElement('div');
      temp.innerHTML = request.response;

      var incoming = temp.querySelector('.related-products-carousel');
      if (!incoming) return;

      section.innerHTML = incoming.innerHTML;

      // --- Opcional: mitigación de nested swipe ---
      initNestedSwipeMitigation(section);
    }
  };
  request.send();
};

function initNestedSwipeMitigation(root) {
  // Cuando el usuario toca/arrastra dentro del carrusel interno de medios del product card,
  // pausamos el outer slider para evitar conflictos de gesto.
  var outer = root.closest('carousel-slider') || root.querySelector('carousel-slider');
  if (!outer) return;

  var touchTargets = root.querySelectorAll(
    '.product-block [data-media-slider], .product-block .js-media-slider, .product-block .product__media-slider, .product-block .product-gallery'
  );

  if (!touchTargets.length) return;

  var onTouchStart = function() {
    outer.classList.add('nested-swipe-active');
  };
  var onTouchEnd = function() {
    outer.classList.remove('nested-swipe-active');
  };

  touchTargets.forEach(function(el) {
    el.addEventListener('touchstart', onTouchStart, { passive: true });
    el.addEventListener('touchend', onTouchEnd, { passive: true });
    el.addEventListener('touchcancel', onTouchEnd, { passive: true });
  });
}

// Reload when editing in the theme editor
document.addEventListener('shopify:section:load', function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products-carousel')) {
    loadProductRecommendationsIntoSection();
  }
});

// Initial fetch
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products2"] && !Shopify.designMode) return;
  try {
    
var loadRelatedProductsCarousel = function() {
  // Select custom class for this carousel section
  var productRecommendationsSection = document.querySelector(".related-products-carousel");
  if (productRecommendationsSection === null) { return; }
  
  // Create request
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      // Inject the HTML inside
      productRecommendationsSection.innerHTML = container.querySelector(".related-products-carousel").innerHTML;
      
      // Symmetry Theme specific: The carousel needs to be initialized. 
      // Because we injected HTML with <carousel-slider>, the custom element should auto-upgrade.
      // However, if the theme uses specific initializers for quickbuy or animations, they usually auto-detect or might need a trigger.
      // The theme's global JS usually observes DOM changes, so this should work natively.
    }
  };
  request.send();
};

// Event listeners for Shopify Editor and Page Load
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products-carousel')) {
    loadRelatedProductsCarousel();
  }
});
loadRelatedProductsCarousel();

  } catch(e) { console.error(e); }
})();
})();
